module.exports = __webpack_public_path__ + "img/cspacefooterimg.57e7363b.svg";